export const ACCREDITED_AND_LINKED_BANK_ACCOUNT = 'at.accreditedAndLinkedBankAccount';
export const ACCOUNT_CREATED = 'at.accountCreated';
export const SIGN_UP = 'at.signUp';
export const HUBSPOT_FORM_SUBMIT = 'hs.formSubmit';
export const VERIFIED_PERSON = 'at.verifiedPerson';
export const ACCREDITATION_AFTER_REGISTER = 'at.accreditationAfterRegister';
export const ACCREDITED_ONCE = 'at.accreditedOnce';
export const PAGE_RESOLVED = 'at.pageResolved';
export const PAGE_VIEW = 'at.pageView';
export const COMPLETED_INVESTMENT = 'at.completedInvestment';
export const COMPLETED_PLEDGE = 'at.completedPledge';
export const LINKED_BANK_ACCOUNT = 'at.linkedBankAccount';
export const VIEW_FARM = 'at.viewFarm';
export const START_INVESTMENT = 'at.startFarmInvest';
export const INVESTMENT_AMOUNT = 'at.farmInvestmentAmountInputted';
export const INVESTMENT_PROFILE = 'at.farmInvestmentUserInfoInputted';
export const INVESTMENT_OWNERSHIP = 'at.farmInvestmentPrimaryInvestorInputted';
export const INVESTMENT_SIGNATURES = 'at.farmInvestmentSignaturesInputted';
export const INVESTMENT_ESCROW = 'at.farmInvestmentFundingInputted';
export const INVESTMENT_ACCREDITATION = 'at.farmInvestmentAccreditation';
export const INVESTMENT_CONFIRMATION = 'at.farmInvestmentConfirmation';
export const WALLET_FUNDS_ADDED = 'at.walletFundsAdded';
export const EXPLAINER_WATCH_START = 'at.explainerOnSiteWatchStart';
export const EXPLAINER_WATCH_END = 'at.explainerOnSiteWatchEnd';
